import { render, staticRenderFns } from "./AppUser.vue?vue&type=template&id=a271c012&scoped=true&"
import script from "./AppUser.vue?vue&type=script&lang=js&"
export * from "./AppUser.vue?vue&type=script&lang=js&"
import style0 from "./AppUser.vue?vue&type=style&index=0&id=a271c012&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a271c012",
  null
  
)

export default component.exports